export default __webpack_public_path__ + "media/images/preview-40aea148a7a2c2fbb40a737d08b06de9.jpg";